import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIService } from '../apiservices/apiservices';

@Injectable()
export class UsuariosProvider {
  private header=APIService.getHeader();
  itemret;

  constructor(public http: HttpClient) {
  }
  
  /**
   * Lista usuários
   * @param filtro filtro de nome ou cpf do usuário
   * @returns 
   */
  get(filtro:any) {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      let url = APIService.API_URL + 'usuarios?filtro=' + filtro;
      
      me.http.get(url,{headers:me.header})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              var errodatavazio={
                'Item':null,
                'erro':'Erro na consulta do usuário.'
              }
              me.itemret=errodatavazio;
            }
            
            //resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Nenhum registro encontrado.'
            }
            me.itemret=errodatavazio1;
          }
          resolve(me.itemret);
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }

  /**
   * Atualiza usuário
   * @param usuario json com os dados do usuário
   * @returns 
   */
  addupdate(usuario:any) {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      var requestData=JSON.stringify(usuario);
      let url = APIService.API_URL + 'usuarios';
      
      me.http.post(url,requestData,{headers:me.header})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              var errodatavazio={
                'Item':null,
                'erro':'Erro na atualização do usuário.'
              }
              me.itemret=errodatavazio;
            }
            
            resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Não há consultas.'
            }
            me.itemret=errodatavazio1;
          }
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }


  delete(guid:any) {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      let url = APIService.API_URL + 'usuarios?id=' + guid;
      
      me.http.delete(url,{headers:me.header})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              var errodatavazio={
                'Item':null,
                'erro':'Erro na exclusão do usuário.'
              }
              me.itemret=errodatavazio;
            }
            
            resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Nenhum registro encontrado.'
            }
            me.itemret=errodatavazio1;
          }
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }

  
  

}
